import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const ownershipFields: FieldInterface[] = [
  {
    key: 'fullOwnershipPart', // PP
    originKey: 'full_ownership_part',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'bareOwnershipPart', // NP
    originKey: 'bare_ownership_part',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'bareOwnershipTerm',
    originKey: 'bare_ownership_term',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'usufructPart', // UP
    originKey: 'usufruct_part',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'usufructTerm',
    originKey: 'usufruct_term',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'birthDateOfUsufructer',
    originKey: 'birth_date_of_usufructer',
    type: FIELD_TYPES.date,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'ownershipCode',
    originKey: 'ownership_code',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isOptional,
  },
]

const ownershipRelations: RelationInterface[] = [
  {
    key: '_portfolio',
    originKey: 'portfolio',
    objectType: OBJECT_TYPES.portfolio,
    isMultiple: false,
  },
  {
    key: '_holder',
    originKey: 'holder',
    objectType: OBJECT_TYPES.person,
    isMultiple: false,
  },
]

export { ownershipFields, ownershipRelations }
